import { render, staticRenderFns } from "./typeDetail.vue?vue&type=template&id=34c44eee&scoped=true&"
import script from "./typeDetail.vue?vue&type=script&lang=js&"
export * from "./typeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c44eee",
  null
  
)

export default component.exports